export enum CertificationStep {
  ApplicantAccountholder = 0,
  Search = 1,
  Visualize = 2,
  ChooseCertificate = 3,
  Print = 4,
}
